import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

// Create meeting request
export const createMeetingRequest = createAsyncThunk(
    "meetingRequest/create",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await api.create("/api/meeting-requests", data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// Get meeting requests
export const getMeetingRequests = createAsyncThunk(
    "meetingRequest/getAll",
    async (type: string = 'all', { rejectWithValue }) => {
        try {
            const response = await api.get("/api/meeting-requests", { type });
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// Check availability for slot
export const checkAvailabilityForSlot = createAsyncThunk(
    "meetingRequest/checkAvailability",
    async (data: { user_ids: string[], start_datetime: string, end_datetime: string }, { rejectWithValue }) => {
        try {
            const response = await api.create("/api/availability/check", data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

